(() => {
  function init(scope) {
    scope.querySelectorAll('[data-dd-banner-slider]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const track = root.querySelector('[data-bs-track]');
      const slides = [...root.querySelectorAll('[data-bs-slide]')];
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const interval = Number(root.dataset.interval) || 5000;
      const autoplay = root.dataset.autoplay === 'true';
      let index = 0, visible = false, last = Date.now();

      const mark = () => slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      const go = n => {
        index = (n + slides.length) % slides.length;
        track.scrollTo({ left: slides[index].offsetLeft, behavior: reduced.matches ? 'auto' : 'smooth' });
        last = Date.now();
        mark();
      };

      root.addEventListener('click', e => {
        if (e.target.closest('[data-bs-prev]')) go(index - 1);
        else if (e.target.closest('[data-bs-next]')) go(index + 1);
      });
      root.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      });

      // Keep the active slide in sync when people swipe the track themselves.
      let settle;
      track.addEventListener('scroll', () => {
        clearTimeout(settle);
        settle = setTimeout(() => {
          const n = Math.round(track.scrollLeft / track.clientWidth);
          if (n !== index && slides[n]) { index = n; last = Date.now(); mark(); }
        }, 120);
      }, { passive: true });

      const observer = new IntersectionObserver(entries => visible = entries[0].isIntersecting, { threshold: .3 });
      observer.observe(root);
      const timer = setInterval(() => {
        if (!root.isConnected) { clearInterval(timer); observer.disconnect(); return; }
        const busy = root.matches(':hover') || root.contains(document.activeElement);
        if (autoplay && visible && !busy && !document.hidden && !reduced.matches && slides.length > 1 && Date.now() - last >= interval) go(index + 1);
      }, 500);

      mark();
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest('[data-dd-banner-slider]');
    const track = root && root.querySelector('[data-bs-track]');
    if (track) track.scrollTo({ left: event.target.offsetLeft, behavior: 'auto' });
  });
})();
